import { Translate } from 'react-redux-i18n'
import { Element } from '../../../common/html/element'
import { Panel } from '../../../common/panel'
import { PANEL_EMAIL_SETTING_ID, SETTING_KEYS } from '../constant'
import { SettingItem } from './SettingItem'

export const EmailSetting = () => {
  return (
    <Panel
      label="alertSetting.EMAIL_SETTINGS"
      isI18n
      id={PANEL_EMAIL_SETTING_ID}
    >
      <div style={{ padding: '8px 12px' }}>
        <Element className="fstItalic" style={{ color: '#3A414B' }}>
          <Translate value="alertSetting.CONFIGUE_EMAIL_SETTINGS_FOR_ALERTS" />
        </Element>
        <SettingItem
          settingKey={SETTING_KEYS.EMAIL}
          title="alertSetting.ALERT_EMAIL"
          description="alertSetting.ALERT_EMAIL_DESC"
        />
        <SettingItem
          settingKey={SETTING_KEYS.EMAIL_DIGEST}
          title="alertSetting.ALERT_EMAIL_DIGEST"
          description="alertSetting.ALERT_EMAIL_DIGEST_DESC"
        />
      </div>
    </Panel>
  )
}
